import { render, staticRenderFns } from "./DashFees.vue?vue&type=template&id=ab46f924&scoped=true&"
import script from "./DashFees.vue?vue&type=script&lang=js&"
export * from "./DashFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab46f924",
  null
  
)

export default component.exports